/**
 * For input components that allow multiple value as array.
 */
export default {
  props: {
    /**
     * Value to be edited. Array by default if multiple.
     * @model
     */
    value: {
      type: [String, Array],
      default() {
        return this.multiple ? [] : null;
      },
    },
    /**
     * Allow input to accept multiple value as array.
     */
    multiple: Boolean,
    /**
     * Use full filled background color style.
     */
    filled: {
      type: Boolean,
      default() {
        return !this.multiple;
      },
    },
    /**
     * Use chips for each item. Enabled if `multiple` by default.
     */
    chips: {
      type: Boolean,
      default() {
        return this.multiple;
      },
    },
    /**
     * Use small chips.
     */
    smallChips: Boolean,
  },
  computed: {
    /**
     * Array of select / autocomplete options
     * When prop 'reference' is set, it means that items are fetched by the input itself, rather
     * than being passed from a client project via 'choices' prop. Whenever items are fetched by the input itself,
     * 'items' data variable is the one that contains all the possible select / autocomplete items, instead of prop 'choices'.
     */
    inputOptions() {
      return !!this.reference ? this.items || [] : this.choices;
    },
    selectedItems() {
      return this.inputOptions.filter((item) => {
        const choice = item[this.getItemValue] || item;
        return this.value && this.value.includes(choice);
      });
    },
    /**
     * Indicates that All of the select options are selected
     */
    allItemsSelected() {
      if (!Array.isArray(this.value)) return false;
      return this.value.length === this.inputOptions.length;
    },
    /**
     * Indicates that some of the select options are selected
     */
    someItemsSelected() {
      if (!Array.isArray(this.value)) return false;
      return this.value.length > 0 && !this.allItemsSelected;
    },
    /**
     * Select All checkbox icon (for all selected, none selected and indeterminate states)
     */
    icon() {
      if (this.allItemsSelected) return "mdi-close-box";
      if (this.someItemsSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        // If all items are selected, unselect everything
        if (this.allItemsSelected) {
          this.$emit("change", []);
          this.$emit("input", []);
        } else {
          // If items are objects and :item-value prop is provided
          if (this.getItemValue) {
            const items = this.inputOptions
              .slice()
              .map((item) => item[this.getItemValue]);
            this.$emit("change", items);
            this.$emit("input", items);
          } else {
            const items = this.inputOptions.slice();
            this.$emit("change", items);
            this.$emit("input", items);
          }
        }
      });
    },
  },
};
